import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoreComponent } from './core.component';
import { AclGuard } from '../app-shared/services/acl.guard';
import { DynamicFunctionalityGuard } from '../app-shared/dynamic-functionality/dynamic-functionality.guard';
import { PermissionsGuard } from '../app-shared/services/permissions.guard';
import { allUserPermissions } from '../app-shared/models/user-phermissions.model';

const routes: Routes = [
  {
    path: '',
    component: CoreComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('../home/home.module').then((m) => m.HomeModule),
        canActivate: [AclGuard],
        data: { title: 'Home' },
      },
      {
        path: 'catalog',
        loadChildren: () =>
          import('../catalog/catalog.module').then((m) => m.CatalogModule),
        canActivate: [AclGuard],
        data: { title: 'catalog', breadcrumb: 'catalog' },
      },
      {
        path: 'catalog/tare',
        loadChildren: () =>
          import('../catalog/catalog.module').then((m) => m.CatalogModule),
        canActivate: [AclGuard, DynamicFunctionalityGuard],
        data: { title: 'Catalog Tare', breadcrumb: 'PANELTEXT.return_tare' },
      },
      {
        path: 'cart',
        loadChildren: () =>
          import('../cart/cart.module').then((m) => m.CartModule),
        canActivate: [AclGuard, PermissionsGuard],
        data: {
          title: 'cart-btn',
          permissionId: allUserPermissions.isCreateOrder,
        },
      },
      {
        path: 'orderhistory',
        loadChildren: () =>
          import('../order-history/order-history.module').then(
            (m) => m.OrderHistoryModule
          ),
        canActivate: [AclGuard, PermissionsGuard],
        data: {
          title: 'order-history.title',
          permissionId: allUserPermissions.isShowOrderHistory,
        },
      },
      {
        path: 'cashbackhistory',
        loadChildren: () =>
          import('../cashback-history/cashback-history.module').then(
            (m) => m.CashbackHistoryModule
          ),
        canActivate: [AclGuard, PermissionsGuard],
        data: {
          title: 'Cashback History',
          permissionId: allUserPermissions.isShowLoyalty,
        },
      },
      {
        path: 'user/profile',
        loadChildren: () =>
          import('../profile/admin-profile/admin-profile.module').then(
            (m) => m.AdminProfileModule
          ),
        canActivate: [AclGuard],
        data: { title: 'my_profile' },
      },
      {
        path: 'info',
        loadChildren: () =>
          import('./text/text.module').then((m) => m.TextModule),
        canActivate: [AclGuard],
      },
      {
        path: 'addcategory',
        loadChildren: () =>
          import('../addcategory/addcategory.module').then(
            (m) => m.AddCategoryModule
          ),
        canActivate: [AclGuard],
      },
      {
        path: 'promo',
        loadChildren: () =>
          import('../promotions/promotions.module').then((m) => m.PromotionsModule),
        canActivate: [AclGuard],
        data: { title: 'sales', breadcrumb: 'promo' },
      },
      {
        path: 'information',
        loadChildren: () =>
          import('../information/information.module').then((m) => m.InformationModule),
        canActivate: [AclGuard],
        data: { title: 'information-banner.title'},
      },
      {
        path: 'equipment',
        loadChildren: () =>
          import('../equipment/equipment.module').then((m) => m.EquipmentModule),
        canActivate: [AclGuard],
        data: { title: 'equipment.equipment-menu-item', breadcrumb: 'equipment.equipment-menu-item' },
      },
      {
        path: 'license',
        loadChildren: () =>
          import('../auth-layout/license/license.module').then((m) => m.LicenseModule),
        data: { title: 'License' },
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('../reports/reports.module').then(
            (m) => m.ReportsModule
          ),
        canActivate: [AclGuard, PermissionsGuard],
        data: { title: 'reports-module.title', permissionId: allUserPermissions.isShowAnalytics,},
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
